<script>
  import Chart from "chart.js/auto";
  import AdSlot from "../../components/ads/AdSlot.svelte";

  import {
    panelController,
    modalStore,
    messrest,
    searchDoc,
    updateD,
    modalS,
  } from "../../stores/service";

  import { onDestroy } from "svelte";
  import { PolarArea, Bar, Line, Radar } from "svelte-chartjs";
  import { userRol } from "../../stores/user";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";

  /*   Chart.register(
    Title,
    Tooltip, 
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  ); */

  import {
    muestras,
    fechaFormateada1 as f1,
    fechaFormateada2 as f2,
    bItems,
  } from "../../stores/CES";

  /*  ChartJS.register(Titl, Tool, Lengen, ArcElement, RadialLinearScale);
  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale
  ); */

  document.title = "Ratingg | Principal";

  let fechaFormateada1 = f1;
  let fechaFormateada2 = f2;
  let segundosArray = []; // Ejemplo de arreglo de segundos
  let promedios;

  let dataline = {
    labels: [],
    datasets: [
      {
        label: "Tiempo",
        fill: true,
        lineTension: 0.3,
        backgroundColor: "rgba(225, 204,230, .3)",
        borderColor: "rgb(205, 130, 158)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgb(205, 130,1 58)",
        pointBackgroundColor: "rgb(255, 255, 255)",
        pointBorderWidth: 10,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(0, 0, 0)",
        pointHoverBorderColor: "rgba(220, 220, 220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: [],
      },
      /* {
      label: 'Minutos',
      fill: true,
      lineTension: 0.3,
      backgroundColor: 'rgba(184, 185, 210, .3)',
      borderColor: 'rgb(35, 26, 136)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgb(35, 26, 136)',
      pointBackgroundColor: 'rgb(255, 255, 255)',
      pointBorderWidth: 10,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgb(0, 0, 0)',
      pointHoverBorderColor: 'rgba(220, 220, 220, 1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [],

    }, */
    ],
  };

  function tem(time) {
    if (time > 0) {
      let minutos = Math.floor(time / 60);
    let segundos = time % 60;
    if (minutos < 1) {
      if (segundos < 10) {
        return `00:0${segundos}`;
      } else {
        return `00:${segundos}`;
      }
    } else {
      if (minutos < 10) {
        if (segundos < 10) {
          return `0${minutos}:0${segundos}`;
        } else {
          return `0${minutos}:${segundos}`;
        }
      } else {
        if (segundos < 10) {
          return `${minutos}:0${segundos}`;
        } else {
          return `${minutos}:${segundos}`;
        }
      }
    }
    }else{
      return `00:00`;
    }
    
  }

  function calcularDiferenciaDeTiempo(momentoInicial) {
    const timestamp = momentoInicial;
    const fecha = new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1e6
    );
    const momentoActual = new Date();
    const diferencia = momentoActual - fecha;
    const segundosPasados = Math.floor(diferencia / 1000);
    /* console.log("seg", segundosPasados); */
    return segundosPasados;
  }

  function calcularTiempoTranscurrido(t1, t2) {
    const fecha1 = new Date(t1.seconds * 1000 + t1.nanoseconds / 1e6);
    const fecha2 = new Date(t2.seconds * 1000 + t2.nanoseconds / 1e6);

    const diffMs = fecha2 - fecha1;

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return { minutes, seconds };
  }

  function promtime(item) {
    item.listServices.forEach((element) => {
      $panelController.viewDashboard.time.push(
        calcularTiempoTranscurrido(element.start, element.end)
      );

      if (
        $panelController.viewDashboard.time[
          $panelController.viewDashboard.time.length - 1
        ].minutes > 0
      ) {
        dataline.labels.push(
          `${$panelController.viewDashboard.time[$panelController.viewDashboard.time.length - 1].seconds}`
        );
      } else {
        dataline.labels.push(
          `${$panelController.viewDashboard.time[$panelController.viewDashboard.time.length - 1].minutes} : ${$panelController.viewDashboard.time[$panelController.viewDashboard.time.length - 1].seconds}`
        );
      }
      dataline.datasets[0].data.push(
        $panelController.viewDashboard.time[
          $panelController.viewDashboard.time.length - 1
        ].seconds
      );

      $panelController.viewDashboard.promTime =
        dataline.datasets[0].data[dataline.datasets[0].data.length - 1] +
        $panelController.viewDashboard.promTime;
    });
  }

  onMount(async () => {
    $panelController.viewDashboard.promTime = 0;
    $panelController.viewDashboard.time = [];
    if ($panelController.service.service.mode == 1) {
        if (dataline.datasets[0].data.length > 0) {
        $panelController.viewDashboard.promTime =
          dataline.datasets[0].data.reduce(
            (acumulador, objeto) => acumulador + objeto,
            0
          ) / dataline.datasets[0].data.length;
      }  
      $panelController.viewDashboard.tendMesas.datasets[0].data = [];
       $panelController.service.service.mesasService.forEach((element,index) => {
        $panelController.viewDashboard.tendMesas.datasets[0].data[index] = 0;
        $panelController.viewDashboard.tendMesas.labels[index] = index + 1;
      });  
      }


    if ($panelController.viewDashboard.status == false) {
      metododas();
      $panelController.viewDashboard.status = true;
     /*  $panelController.viewDashboard.nav = true; */

    }
  });

  function validarResp(value) {
    
  // Si no es un arreglo, conviértelo en uno
  const values = Array.isArray(value) ? value : [value];
  
  // Filtra y convierte valores
  return values
    .map(item => {
      if (typeof item === 'number') {
        return item; // Devuelve el valor si ya es un número
      } else if (typeof item === 'string' && item.trim() !== '' && !isNaN(item)) {
        return Number(item); // Convierte y devuelve si es una cadena numérica
      } else {
        return null; // Marca como null si es una cadena vacía o no numérica
      }
    })
    .filter(item => item !== null); // Filtra los valores nulos (no numéricos)
  }

  function metododas() {
    $panelController.viewDashboard.datalist = {};
    $panelController.viewSondeosPanel.ratinggs.forEach((item) => {
      if ($panelController.service.service.mode == 1) {
        if (item.hasOwnProperty("listServices")) {
        promtime(item);
      }
      if (item.hasOwnProperty("mesa")) {
        
        $panelController.viewDashboard.tendMesas.datasets[0].data[item.mesa-1]++;
        
      }
      }
      if (item.hasOwnProperty("rattinggs")) {
        item.rattinggs.forEach((items, index) => {
        if (items.tipo == 1 || items.tipo == 2 || items.tipo == 3) {

          const respuestas = validarResp(items.respuesta);

          if (!$panelController.viewDashboard.datalist[items.pregunta]) {
            $panelController.viewDashboard.datalist[items.pregunta] = {
              recuento: {},
              pregunta: items.pregunta,
              tipo: items.tipo,
              data: {
                labels: [` ${index + 1}. ${items.pregunta}`],
                datasets: [],
              },
              dataPolarArea: {
                datasets: [],
              },
              btnT: false,
            };
            switch (items.tipo) {
              case 1:
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.datasets.push({
                  data: [],
                  backgroundColor: [],
                  label: [` ${items.nPregunta}. ${items.pregunta}`],
                });

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.labels = [];

                items.checks.forEach((respuesta) => {
                  const red = Math.floor(Math.random() * 256);
                  const green = Math.floor(Math.random() * 256);
                  const blue = Math.floor(Math.random() * 256);

                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].data.datasets.push({
                    label: respuesta,
                    data: [0],
                    backgroundColor: [`rgba(${red}, ${green}, ${blue}, 0.5)`],
                    borderWidth: 1,
                    borderColor: [`rgba(${red}, ${green}, ${blue}, 1)`],
                  });
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].dataPolarArea.datasets[0].backgroundColor.push(
                    `rgba(${red}, ${green}, ${blue}, 1)`
                  );
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].dataPolarArea.datasets[0].data.push(0);
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].dataPolarArea.labels.push(respuesta);
                });
                break;
              case 3:
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].data.datasets.push(
                  {
                    label: "Muy Malo",
                    data: [0],
                    backgroundColor: ["rgba(255, 0, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(255, 0, 0, 1)"],
                  },
                  {
                    label: "Malo",
                    data: [0],
                    backgroundColor: ["rgba(255, 0, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(255, 0, 0, 1)"],
                  },
                  {
                    label: "Regular",
                    data: [0],
                    backgroundColor: ["rgba(247, 252, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(247, 252, 0, 1)"],
                  },

                  {
                    label: "Bueno",
                    data: [0],
                    backgroundColor: ["rgba(0, 247, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(0, 247, 0, 1)"],
                  },
                  {
                    label: "Muy bueno",
                    data: [0],
                    backgroundColor: ["rgba(0, 247, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(0, 247, 0, 1)"],
                  }
                );
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.datasets.push({
                  data: [0, 0, 0, 0, 0],
                  backgroundColor: [
                    "rgba(255, 0, 0, 0.5)",
                    "rgba(255, 0, 0, 0.5)",
                    "rgba(247, 252, 0, 0.5)",
                    "rgba(0, 247, 0, 0.5)",
                    "rgba(0, 247, 0, 0.5)",
                  ],
                  label: [` ${items.nPregunta}. ${items.pregunta}`],
                });
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.labels = [
                  "Malo",
                  "Muy Malo",
                  "Regular",
                  "Bueno",
                  "Muy bueno",
                ];
                break;
              case 2:
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].data.datasets.push(
                  {
                    label: "Malo",
                    data: [0],
                    backgroundColor: ["rgba(255, 0, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(255, 0, 0, 1)"],
                  },

                  {
                    label: "Regular",
                    data: [0],
                    backgroundColor: ["rgba(247, 252, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(247, 252, 0, 1)"],
                  },

                  {
                    label: "Bueno",
                    data: [0],
                    backgroundColor: ["rgba(0, 247, 0, 0.5)"],
                    borderWidth: 1,
                    borderColor: ["rgba(0, 247, 0, 1)"],
                  }
                );
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.datasets.push({
                  data: [0, 0, 0],
                  backgroundColor: [
                    "rgba(255, 0, 0, 0.5)",
                    "rgba(247, 252, 0, 0.5)",
                    "rgba(0, 247, 0, 0.5)",
                  ],
                  label: [` ${items.nPregunta}. ${items.pregunta}`],
                });

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.labels = [`Malo`, `Regular`, `Bueno`];
                break;
              default:
            }
          }



          respuestas.forEach((respuesta) => {
            if (respuesta !== undefined) {
              if (
                !$panelController.viewDashboard.datalist[items.pregunta]
                  .recuento[respuesta]
              ) {
                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].recuento[respuesta] = 1;
                /* console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'+',$panelController.viewDashboard.datalist[items.pregunta].recuento[respuesta]) */

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].data.datasets[respuesta].data[0] =
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].recuento[respuesta];

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.datasets[0].data[respuesta] =
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].recuento[respuesta];

                /* console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'+',$panelController.viewDashboard.datalist[items.pregunta].data.datasets[respuesta].data)
                  console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'recuento',$panelController.viewDashboard.datalist[items.pregunta].dataPolarArea.datasets[0].data) */
              } else {
                $panelController.viewDashboard.datalist[items.pregunta]
                  .recuento[respuesta]++;
                /*  console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'+',$panelController.viewDashboard.datalist[items.pregunta].recuento[respuesta]) */

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].data.datasets[respuesta].data[0] =
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].recuento[respuesta];

                /* console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'+',$panelController.viewDashboard.datalist[items.pregunta].data.datasets[respuesta].data) */

                $panelController.viewDashboard.datalist[
                  items.pregunta
                ].dataPolarArea.datasets[0].data[respuesta] =
                  $panelController.viewDashboard.datalist[
                    items.pregunta
                  ].recuento[respuesta];
                /* console.log('n.pregunta',$panelController.viewDashboard.datalist[items.pregunta].nPregunta,'recuento',$panelController.viewDashboard.datalist[items.pregunta].dataPolarArea.datasets[0].data) */
              }
            }
          });
        }

        if (
          items.tipo == 4 &&
          items.respuesta.length > 0 &&
          Array.isArray(items.respuesta) === false
        ) {
          if (!$panelController.viewDashboard.datalist[items.pregunta]) {
            $panelController.viewDashboard.datalist[items.pregunta] = {
              pregunta: items.pregunta,
              nPregunta: index + 1,
              tipo: items.tipo,
              respuestas: [items.respuesta],
            };
          } else {
            $panelController.viewDashboard.datalist[
              items.pregunta
            ].respuestas.push(items.respuesta);
          }
        }
      });
      }
        
    });
  }

  
</script>

{#if $panelController.viewDashboard.status}
  <!-- <button on:click={consoleLog}>
btn
</button> -->


  <h3 class="text-center">
    {$panelController.service.listRatinggs[
      $panelController.viewSondeosPanel.index
    ].config.name}
  </h3>

  <div class="text-center mb-3">
    <AdSlot />
  </div>

  <div class="row">
    <!-- ./col -->
    <div class="col-{$panelController.service.service.mode == 1 ? '4' : '12'}">
      <!-- small box -->
      <div class="small-box bg-danger">
        <div class="inner">
          <h3>{$panelController.viewSondeosPanel.ratinggs.length}</h3>
          <p>Ratings</p>
        </div>
        <div class="icon">
          <i class="ion ion-ios-people"/>
        </div>
      </div>
    </div>

    {#if $panelController.service.service.mode == 1}
      <div class="col-4">
        <!-- small box -->
        <div class="small-box bg-secundary">
          <div class="inner">
            <h3>{$panelController.viewDashboard.time.length}</h3>
            <p>Times</p>
          </div>
          <div class="icon">
            <i class="ion ion-ios-clock" />
          </div>
        </div>
      </div>

      <div class="col-4">
        <!-- small box -->
        <div class="small-box bg-primary">
          <div class="inner">
            <h3>{tem($panelController.viewDashboard.promTime)}
              
            </h3>
            <p>Promedio</p>
          </div>
          <div class="icon">
            <i class="ion ion-pie-graph" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <!-- AREA CHART -->
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Marcas de tiempo</h3>

              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="remove"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>

            <Line
              data={dataline}
              options={{
                responsive: true,
                transitions: {
                  show: {
                    animations: {
                      x: {
                        from: 0,
                      },
                      y: {
                        from: 0,
                      },
                    },
                  },
                  hide: {
                    animations: {
                      x: {
                        to: 0,
                      },
                      y: {
                        to: 0,
                      },
                    },
                  },
                },
                plugins: {
                  legend: {
                    position: "top",
                  },
                  title: {
                    display: true,
                    text: "Time",
                  },
                },
              }}
            />

            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <div class="col-md-6">
          <!-- AREA CHART -->
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Mesas en tendencia</h3>

              <div class="card-tools">
                <!-- <button
                type="button"
                class="btn btn-tool"
                
              >
              <i class="bi bi-bar-chart-line"/>
              </button> -->
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="remove"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>

            <Line
              data={$panelController.viewDashboard.tendMesas}
              options={{
                responsive: true
                }}
            />

            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-12">
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Rendimeinto semanal</h3>

              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="remove"
                >
                  
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>

            <Radar
              data={$panelController.viewDashboard.charts[0]}
              options={{
                responsive: true,
              }}
            />

          </div>
        </div>
      </div> -->
    {/if}

    <!-- ./col -->
  </div>

  <div class="row">
    {#each Object.keys($panelController.viewDashboard.datalist) as key (key)}
      {#if $panelController.viewDashboard.datalist[key].tipo != 4}
        <div class="col-md-6">
          <!-- AREA CHART -->
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">
                {$panelController.viewDashboard.datalist[key].pregunta}
              </h3>

              <div class="card-tools">
                
                <button
                  type="button"
                  class="btn btn-tool"
                  on:click={() =>
                    ($panelController.viewDashboard.datalist[key].btnT = true
                      )}
                >
                  <i class="ion ion-pie-graph" />
                </button>
                <button
                  type="button"
                  class="btn btn-tool"
                  on:click={() =>
                    ($panelController.viewDashboard.datalist[key].btnT =
                      false)}
                >
                  <i class="bi bi-bar-chart-line" />
                </button>
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="remove"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>

            {#if $panelController.viewDashboard.datalist[key].btnT}
              <PolarArea
                data={$panelController.viewDashboard.datalist[key]
                  .dataPolarArea}
              />
            {:else}
              <Bar data={$panelController.viewDashboard.datalist[key].data} />
            {/if}

            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      {:else} 
        <div class="col-md-12">
          <!-- AREA CHART -->
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">
                {$panelController.viewDashboard.datalist[key].pregunta}
              </h3>

              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="remove"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </div>
            <div class="card-body">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Registro</th>

                    <!-- <th scope="col">id</th> -->
                  </tr>
                </thead>
                <tbody>
                  {#each $panelController.viewDashboard.datalist[key].respuestas as respuestas, item}
                    <tr>
                      <th scope="row">{item + 1}</th>
                      <td>
                        {respuestas}
                      </td>

                      <!-- <td scope="row">{objeto.id}</td>   -->
                    </tr>
                  {/each}
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      {/if}
    {/each}
  </div>
{/if}
